export const leaderboardRefreshInterval = 5000;
export const fetchTimeout = 5000;
export const apiBaseUrl = process.env.REACT_APP_BASEURL;
